import { PUT_HOW_TO_APPLY_START } from '../../types';

export const put_how_to_apply = (payload) => ({
  type: PUT_HOW_TO_APPLY_START,
  payload,
});
